/**
 * Por dónde sale un mensaje del agente, según el canal del chat.
 *
 * Se extrae de `ChatDetalle` por el mismo motivo que `CuerpoMensaje`: la decisión vivía
 * dentro de un `if/else if/else` a cuatro niveles dentro de un componente que no se puede
 * montar en un test sin sus contextos y su Firestore. Aquí es una función pura y se prueba
 * en tres líneas.
 *
 * La decisión que codifica —y que es el defecto que se corrigió el 19-ago—: Instagram,
 * TikTok y Messenger caían en el mismo `else` que Baileys y se ESCRIBÍAN en Firestore, donde
 * nadie los entregaba. El agente veía su mensaje pintado y el cliente no lo recibía nunca.
 */

/** Canales que se entregan por `sendMessage` usando una cuenta concreta (`channelAccounts`). */
export const CANALES_POR_CUENTA = ['instagram', 'tiktok', 'messenger'];

/**
 * @returns {'cloud'|'cuenta'|'baileys'}
 *   - `cloud`   → WhatsApp Cloud API (rama propia, con su `numeroId`)
 *   - `cuenta`  → `sendMessage` con `accountId` derivado del chat en el backend
 *   - `baileys` → escritura en Firestore; es el ÚNICO canal que se entrega así
 */
export function rutaDeEnvio(canal, { isWaCloudChat = false } = {}) {
  if (isWaCloudChat) return 'cloud';
  if (CANALES_POR_CUENTA.includes(canal)) return 'cuenta';
  return 'baileys';
}
